var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderThemeSwitchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.758 22.486C5.825 22.486 1 17.66 1 11.728a10.7 10.7 0 012.912-7.355 10.704 10.704 0 017.104-3.372.537.537 0 01.46.861A9.107 9.107 0 009.54 7.507c0 5.07 4.126 9.197 9.197 9.197.538 0 1.088-.048 1.632-.15a.542.542 0 01.538.227c.12.174.126.401.012.586a10.705 10.705 0 01-9.16 5.119zM9.928 2.221c-4.485.86-7.858 4.831-7.858 9.508 0 5.34 4.348 9.687 9.688 9.687a9.627 9.627 0 007.576-3.648 10.1 10.1 0 01-.598.018c-5.663 0-10.273-4.61-10.273-10.273 0-1.896.502-3.702 1.465-5.292z",
    fill: "#396CF3",
    stroke: "#40C067",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderThemeSwitchDark);
export default __webpack_public_path__ + "static/media/header-theme-switch-dark.e00d21060eed096744031fb953029878.svg";
export { ForwardRef as ReactComponent };